import React from "react";
import { Spinner } from "react-bootstrap";

const LoaderIcon = (props) => {
  return (
    <div className="text-center" style={{ marginTop: "calc(30vh)" }}>
      <Spinner animation="border" />
    </div>
  );
};

export default LoaderIcon;
